// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.83-TSS-3092-mcastro-ENRICHING-DOCUMENTS-COLUMN-Hyperlinks-Download-Function.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
